module.exports = __webpack_public_path__ + "static/intro.six-4ac8a6c7e0f97225a59238d3c6a3372b.png";